import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Register() {
  const { register, error, setError } = useAuth();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const ok = await register(name, email, password);
    setLoading(false);
    if (ok) navigate("/");
  };

  return (
    <div className="min-h-screen bg-[#FDFCF8] grid md:grid-cols-2">
      <div className="hidden md:block relative overflow-hidden">
        <img
          alt=""
          src="https://images.unsplash.com/photo-1598764557991-b9f211b73b81?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwyfHxtb25zdGVyYSUyMHBsYW50JTIwc3VubGlnaHQlMjBtaW5pbWFsfGVufDB8fHx8MTc4MzkwNTEyM3ww&ixlib=rb-4.1.0&q=85"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-[#FDFCF8]/40 to-[#2F4F4F]/60" />
        <div className="absolute bottom-10 left-10 right-10 text-[#FDFCF8]">
          <div className="text-xs tracking-[0.3em] uppercase opacity-80">Get started</div>
          <h2 className="font-display text-4xl mt-2 leading-tight max-w-sm">
            Your money, mapped.
          </h2>
        </div>
      </div>

      <div className="flex items-center justify-center p-8">
        <form
          data-testid="register-form"
          onSubmit={submit}
          className="w-full max-w-sm space-y-6"
        >
          <div>
            <div className="text-xs tracking-[0.2em] uppercase text-[#5C5C5C]">Create account</div>
            <h1 className="font-display text-3xl mt-2">Start with Accountrix</h1>
          </div>

          <div className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="name">Name</Label>
              <Input
                data-testid="register-name"
                id="name" required
                value={name}
                onChange={(e) => { setName(e.target.value); setError(""); }}
                className="h-11"
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="email">Email</Label>
              <Input
                data-testid="register-email"
                id="email" type="email" required
                value={email}
                onChange={(e) => { setEmail(e.target.value); setError(""); }}
                className="h-11"
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password">Password</Label>
              <Input
                data-testid="register-password"
                id="password" type="password" required minLength={6}
                value={password}
                onChange={(e) => { setPassword(e.target.value); setError(""); }}
                className="h-11"
                placeholder="6+ characters"
              />
            </div>
          </div>

          {error && (
            <div data-testid="register-error" className="text-sm text-[#E63946]">
              {error}
            </div>
          )}

          <Button
            data-testid="register-submit"
            type="submit"
            disabled={loading}
            className="w-full h-11 rounded-full bg-[#2F4F4F] hover:bg-[#213838] text-[#FDFCF8]"
          >
            {loading ? "Creating account..." : "Create account"}
          </Button>

          <div className="text-sm text-[#5C5C5C] text-center">
            Already have an account?{" "}
            <Link data-testid="link-login" to="/login" className="text-[#2F4F4F] font-medium underline underline-offset-4">
              Sign in
            </Link>
          </div>

          <div className="text-[11px] text-center text-[#5C5C5C] pt-1">
            By creating an account you agree to our{" "}
            <Link data-testid="link-terms" to="/terms" className="underline underline-offset-2 hover:text-[#2F4F4F]">Terms of Service</Link>
            {" and "}
            <Link data-testid="link-privacy" to="/privacy" className="underline underline-offset-2 hover:text-[#2F4F4F]">Privacy Policy</Link>.
          </div>
        </form>
      </div>
    </div>
  );
}
